import React from 'react';

function StoryblokTeamGrid({ ...rest }) {
  return <div>hi</div>;
}

export default StoryblokTeamGrid;
